/**
 * Checks whether the current org's tier satisfies a required tier.
 *
 * Hierarchy: Activate (base) < Connect / Deliver (parallel) < Unify (all).
 * The backend computes `included_tiers` via the TIER_INCLUDES mapping and
 * returns it in the list-org-identities-tier endpoint response.
 *
 * TODO: Wire up from Redux once the OrgIdentityTier response is stored there.
 */

import { type AccessTier, type OrgIdentityTier, type PricingTier } from '~types'

type UseTierAccessResult = {
  allowed: boolean
  currentTier: PricingTier | null
  loading: boolean
}

export const useTierAccess = (requiredTier: AccessTier): UseTierAccessResult => {
  // TODO: Read the OrgIdentityTier for the current org from Redux state
  // once the list-org-identities-tier response is stored there.
  const orgTier = null as OrgIdentityTier | null

  if (orgTier === null) {
    return { allowed: true, currentTier: null, loading: false }
  }

  const allowed = orgTier.included_tiers.includes(requiredTier)

  return { allowed, currentTier: orgTier.tier, loading: false }
}
